import { render, staticRenderFns } from "./LayoutsWidget.vue?vue&type=template&id=8cd56ac8&scoped=true"
import script from "./LayoutsWidget.vue?vue&type=script&lang=js"
export * from "./LayoutsWidget.vue?vue&type=script&lang=js"
import style0 from "./LayoutsWidget.vue?vue&type=style&index=0&id=8cd56ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd56ac8",
  null
  
)

export default component.exports